import styled from "styled-components";
import { Button as AntButton, Form as AntForm, Input as AntInput } from "antd";

export const ChangePinContainer = styled.div`
	min-height: calc(100vh - 110px);
	display: flex;
	justify-content: flex-start;
	align-items: left;
	flex-direction: column;
	/* padding: 20px 0px; */

	.ant-form-item-label {
		text-align: center;
		font-size: 16px;
	}

	.ant-input {
		text-align: center;
	}
`;

export const Form = styled(AntForm)`
	width: 100%;
	height: 100%;
	position: relative !important;
	padding: 24px 16px 16px 16px;

	.ant-form-item {
		margin: 0 0 24px 0px;
	}

	.ant-form-item-label > label.ant-form-item-required::before {
		content: none;
	}

	.ant-form-item-label label {
		color: #4F4F4F;
		font-size: 16px;
		font-weight: 400;
		line-height: 17.5px;
		display: flex;
		margin-left: 18px;
	}

	.ant-form-item-explain {
		text-align: left; /* align warning text to the left */
		margin-left: 24px;
	}
`;

export const Button = styled(AntButton)`
	margin-top: 20px;
	width: 100% !important;
	height: 52px !important;
`;

export const Input = styled(AntInput.Password)`
	border-radius: 16px;
	border: none;
	height: 54px;
	font-family: 'Archivo', 'Yati' !important;

	input {
		/* font-size: 16px !important ; */
		text-align: left !important;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		color: #4F4F4F !important;
		font-family: 'Archivo', 'Yati' !important;
	}

	input:hover{
		border: none !important;

	}

	.ant-input::placeholder {
		color: #979797 !important;
		font-weight: 400;
		font-size: 16px;
		line-height: 20px;
		font-family: 'Archivo', 'Yati' !important;

	}

	&&& {
		padding-left: 16px;
	}
	&:hover {
		border: none;
	}
`;
